var reconsent = {
	dialog: {
		title: "Profile Completion",
		description: "We still need your consent for the following"
	}
};
var cdcProfile = {
	profileUpdateSuccess: "Profile details successfully updated",
	profileUpdateFailure: "Failed to update profile details"
};
var cdc = {
	reconsent: reconsent,
	cdcProfile: cdcProfile
};

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const en = {
    cdc,
};

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const cdcTranslations = {
    en,
};
const cdcTranslationChunksConfig = {
    cdc: ['reconsent', 'cdcProfile'],
};

/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { cdcTranslationChunksConfig, cdcTranslations };
